import React, { useState, useEffect, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
    Button,
    DatePicker,
    message,
    Space,
    Table,
    Upload,
    Input,
    Row,
    Col,
    Form,
    Popconfirm,
    Modal,
    Tag,
    Descriptions
} from 'antd';

import moment from 'moment';
import PageContent from '../../components/page-content/page-content';
import Box from '../../components/box';
import { postfromqywx, postfromqywxbyspno, postmuti, getAll, deletezcdj, updatefkrq, updatedate } from "../../lib/api_cw_zcdj";
import { getcwcoaAll } from "../../lib/api_cw_coa";
import { LeftOutlined, RightOutlined, UploadOutlined } from "@ant-design/icons";
import XLSX from "xlsx";
import { getDetail, postAdd, postRemove } from "../../lib/api_cw_zcfkd";
import ZcfkdEditModal from "./zcfkd_form_modal";
import ZcfkDetailModal from "./zcfkd_modal";
import useUrlState from '@ahooksjs/use-url-state';


const { Column } = Table;
const { Search } = Input;
const { RangePicker } = DatePicker;

const SP_STATUS_MAP = {
    1: { text: '审批中', color: 'blue' },
    2: { text: '已通过', color: 'green' },
    3: { text: '已驳回', color: 'red' },
    4: { text: '已撤销', color: 'gray' },
    6: { text: '通过后撤销', color: 'orange' },
    7: { text: '已删除', color: 'default' },
    10: { text: '已支付', color: 'cyan' }
};


const Zcsj = (props) => {
    const [allData, setAllData] = useState([]); // 存储所有数据
    const [filteredData, setFilteredData] = useState([]); // 存储筛选后的数据
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loadingQYWX, setLoadingQYWX] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailModal, setDetailModal] = useState(null);
    const [detailModalid, setDetailModalid] = useState(null);
    const [imagePreviewVisible, setImagePreviewVisible] = useState(false);
    const [previewImageList, setPreviewImageList] = useState([]);
    const [previewImageIndex, setPreviewImageIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('马术支出');
    const [fkrq, setFkrq] = useState(null); // 付款日期
    const [spNoSync, setSpNoSync] = useState(''); // 待同步的审批单号
    const [loadingSpNoSync, setLoadingSpNoSync] = useState(false);
    const [spNoModalVisible, setSpNoModalVisible] = useState(false); // 按单号同步弹窗
    const [coaMap, setCoaMap] = useState({}); // 科目映射 {id: 科目信息}
    const [subjectModal, setSubjectModal] = useState(null); // 科目信息弹窗数据
    // 修改提交日期弹窗
    const [dateModal, setDateModal] = useState(null); // 待修改的记录
    const [dateValue, setDateValue] = useState(null); // 提交日期(moment)
    const [dateLoading, setDateLoading] = useState(false);

    // 根据激活的选项卡筛选数据
    const tabData = useMemo(() => {
        if (activeTab === '马术报销') {
            return allData.filter(item => item.ly === '马术报销');
        }
        if (activeTab === '马术退款') {
            return allData.filter(item => item.ly && String(item.ly).indexOf('马术退款') > -1);
        }
        // 马术支出：排除马术报销、马术退款
        return allData.filter(item => item.ly !== '马术报销' && !(item.ly && String(item.ly).indexOf('马术退款') > -1));
    }, [allData, activeTab]);

    // 搜索条件（存入 url 参数，刷新后不丢失）
    const defaultDateRange = [moment().subtract(3, 'months'), moment()];
    const [urlState, setUrlState] = useUrlState({
        sp_no: '',
        ly: '', // 来源
        begin: defaultDateRange[0].format('YYYY-MM-DD'), // 提交日期范围开始
        end: defaultDateRange[1].format('YYYY-MM-DD'), // 提交日期范围结束
        je_min: '', // 金额最小值
        je_max: '', // 金额最大值
        bz: ''
    });
    // 由 url 参数派生出搜索条件（日期还原为 moment 供表单和筛选使用）
    const searchParams = useMemo(() => ({
        sp_no: urlState.sp_no || '',
        ly: urlState.ly || '',
        dateRange: (urlState.begin && urlState.end)
            ? [moment(urlState.begin), moment(urlState.end)]
            : null,
        je_min: urlState.je_min || '',
        je_max: urlState.je_max || '',
        bz: urlState.bz || ''
    }), [urlState]);
    // Form实例
    const [form] = Form.useForm();

    /**
     * 从企业微信同步
     */
    const fetchqywxData = () => {
        setLoadingQYWX(true);
        postfromqywx()
            .then((res) => {
                if (res.code === 0) {
                    message.success(res.message);
                    fetchData();
                }
            })
            .finally(() => {
                setLoadingQYWX(false);
            })
    }

    /**
     * 从企业微信同步指定审批单号的数据（已存在则覆盖更新）
     */
    const handleSyncBySpNo = () => {
        const sp_no = spNoSync.trim();
        if (!sp_no) {
            message.warning('请输入审批单号');
            return;
        }
        setLoadingSpNoSync(true);
        postfromqywxbyspno(sp_no)
            .then((res) => {
                if (res.code === 0) {
                    message.success(res.message);
                    setSpNoModalVisible(false);
                    setSpNoSync('');
                    fetchData();
                } else {
                    message.error(res.message);
                }
            })
            .finally(() => {
                setLoadingSpNoSync(false);
            })
    }

    /**
     * 获取所有数据
     */
    const fetchData = () => {
        setLoading(true);
        getAll()
            .then((res) => {
                if (res.code === 0) {
                    setAllData(res.data.records);
                    setFilteredData(res.data.records); // 初始时显示所有数据
                    // 按记录年份加载科目表，用于科目列展示与弹窗
                    const years = [...new Set((res.data.records || [])
                        .filter(r => r.date)
                        .map(r => moment(r.date).year()))];
                    if (years.length) {
                        fetchCoaData(years);
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }

    /**
     * 加载指定年份的科目表，合并成 {id: 科目} 映射
     */
    const fetchCoaData = (years) => {
        if (!years || years.length === 0) return;
        const map = {};
        Promise.all(years.map(year => getcwcoaAll(year).then((res) => {
            if (res.code === 0) {
                res.data.forEach(item => {
                    map[item.id] = item;
                });
            }
        })))
            .then(() => setCoaMap(map));
    }

    /**
     * 根据科目节点向上追溯，拼出科目全称
     */
    const getCoaPath = (node) => {
        const path = [];
        let cur = node;
        const guard = new Set();
        while (cur && !guard.has(cur.id)) {
            guard.add(cur.id);
            path.unshift(cur.name);
            cur = cur.pid ? coaMap[cur.pid] : null;
        }
        return path.join(' / ');
    }
    // 切换选项卡时重新请求数据
    useEffect(() => {
        fetchData();
        setSelectedRowKeys([]);
        setSelectedRows([]);
    }, [activeTab]);

    // 当搜索条件或选项卡变化时，在本地筛选数据
    useEffect(() => {
        filterData(tabData);
    }, [searchParams, tabData]);

    // 本地数据筛选函数
    const filterData = (sourceData) => {
        let result = [...sourceData];

        // 根据审批编号筛选
        if (searchParams.sp_no) {
            result = result.filter(item =>
                item.sp_no && item.sp_no.includes(searchParams.sp_no)
            );
        }

        // 根据来源筛选
        if (searchParams.ly) {
            result = result.filter(item =>
                item.ly && item.ly.includes(searchParams.ly)
            );
        }

        // 根据提交日期范围筛选
        if (searchParams.dateRange && searchParams.dateRange.length === 2) {
            const startDate = searchParams.dateRange[0].format('YYYY-MM-DD');
            const endDate = searchParams.dateRange[1].format('YYYY-MM-DD');
            result = result.filter(item => {
                if (!item.date) return false;
                return item.date >= startDate && item.date <= endDate;
            });
        }

        // 根据金额范围筛选
        if (searchParams.je_min || searchParams.je_max) {
            const minValue = parseFloat(searchParams.je_min) || 0;
            const maxValue = parseFloat(searchParams.je_max) || Infinity;
            result = result.filter(item =>
                item.je >= minValue && item.je <= maxValue
            );
        }

        // 根据事由筛选
        if (searchParams.bz) {
            result = result.filter(item =>
                item.bz && item.bz.includes(searchParams.bz)
            );
        }

        setFilteredData(result);
    };

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
        },
    };


    const handleChange = (info) => {
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);

            // 在这里处理文件读取
            if (info.file.status === 'done') {
                // 这里通常用于处理上传完成的逻辑，但因为我们不实际上传，所以跳过
            } else if (info.file.status === 'error') {
                // 处理上传失败的逻辑
            }

            // 如果需要读取文件内容，应该使用 info.file.originFileObj
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });


                /* 获取第一个工作表 */
                const worksheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[worksheetName];

                /* 将工作表转换为 JSON 对象 */
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // 在这里你可以使用 jsonData 进行进一步的操作，比如更新组件的状态或发送到服务器
                console.log(jsonData);

                // 移除第一行
                jsonData.shift();

                // 取出所有的审批编号
                const approval_numbers = jsonData.map((row) => row[0]);
                console.log(approval_numbers);

                setLoadingUpload(true);
                postmuti(approval_numbers).then((res) => {
                    if (res.code === 0) {
                        fetchData(); // 导入后重新获取所有数据
                    }
                }).finally(() => {
                    setLoadingUpload(false);
                })

                // ... 后续处理 workbook 的逻辑
            };
            reader.readAsArrayBuffer(info.file.originFileObj);

            // 如果你想更新上传的文件列表（通常用于显示上传进度），可以使用 setFileList
            // setFileList(info.fileList);
        }
    }

    const beforeUpload = (file) => {
        // 这里可以添加一些文件验证逻辑，比如检查文件类型等
        const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
        if (!isExcel) {
            message.error('请上传 Excel 格式的文件！');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('上传文件大小不能超过 2MB!');
        }
        return isExcel && isLt2M;
    };

    // 设置付款日期

    const hasSelected = selectedRowKeys.length > 0;

    const handleGenerateFKD = () => {
        console.log(selectedRows);
        setDetailModal(selectedRows)
        // postAdd(selectedRows).then((res) => {
        //     if (res.code === 0) {
        //         // message.success(res.message);
        //         fetchData(); // 生成付款单后重新获取所有数据
        //         setDetailModal(res.data.id);
        //     }
        // })
    }

    const handleDelete = () => {
        deletezcdj(selectedRowKeys[0]).then((res) => {
            if (res.code === 0) {
                message.success('删除成功');
                fetchData(); // 删除后重新获取所有数据
                setSelectedRowKeys([]);
                setSelectedRows([]);
            }
        })
        // deleteMulti(selectedRowKeys).then((res) => {
        //     if (res.code === 0) {
        //         message.success(res.message);
        //         fetchData(); // 删除后重新获取所有数据
        //         setSelectedRowKeys([]);
        //         setSelectedRows([]);
        //     }
        // })
    }

    // 设置付款日期
    const handleSetFKRQ = () => {
        const formattedFkrq = fkrq ? fkrq.format('YYYY-MM-DD') : null;
        updatefkrq(selectedRowKeys, formattedFkrq).then((res) => {
            if (res.code === 0) {
                message.success(res.message);
                fetchData();
                setSelectedRowKeys([]);
                setSelectedRows([]);
                setFkrq(null);
            }
        })
    }

    // 打开调整入账日期弹窗
    const handleOpenDateModal = (record) => {
        setDateModal(record);
        setDateValue(record.rz_date ? moment(record.rz_date) : null);
    }

    // 保存入账日期（留空=恢复提交日期）
    const handleSaveDate = () => {
        setDateLoading(true);
        updatedate(dateModal.id, dateValue ? dateValue.format('YYYY-MM-DD') : null).then((res) => {
            if (res.code === 0) {
                message.success(res.message);
                setDateModal(null);
                fetchData();
            } else {
                message.error(res.message);
            }
        }).finally(() => {
            setDateLoading(false);
        });
    }

    // 搜索处理函数
    const handleSearch = (values) => {
        setUrlState({
            sp_no: values.sp_no || '',
            ly: urlState.ly || '',
            begin: values.dateRange && values.dateRange[0] ? values.dateRange[0].format('YYYY-MM-DD') : '',
            end: values.dateRange && values.dateRange[1] ? values.dateRange[1].format('YYYY-MM-DD') : '',
            je_min: values.je_min || '',
            je_max: values.je_max || '',
            bz: values.bz || ''
        });
    };

    // 重置搜索条件
    const handleReset = () => {
        form.setFieldsValue({
            sp_no: '',
            ly: '',
            dateRange: defaultDateRange,
            je_min: '',
            je_max: '',
            bz: ''
        });
        setUrlState({
            sp_no: '',
            ly: '',
            begin: defaultDateRange[0].format('YYYY-MM-DD'),
            end: defaultDateRange[1].format('YYYY-MM-DD'),
            je_min: '',
            je_max: '',
            bz: ''
        });
    };

    const exportXlsx = () => {
        const exportData = filteredData.map(item => ({
            '审批编号': item.sp_no || '',
            '来源': item.ly || '',
            '提交日期': item.date || '',
            '金额': item.je || 0,
            '事由': item.bz || '',
            '提交人': item.applyer || '',
            '附件数量': item.images ? (() => { try { return JSON.parse(item.images).length; } catch { return 0; } })() : 0,
            '支出方式': item.zcfs || '',
            '审批状态': SP_STATUS_MAP[item.sp_status] ? SP_STATUS_MAP[item.sp_status].text : item.sp_status || '',
            '合并付款单': item.fkd_id ? item.fkd_id : '未生成'
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '支出数据');
        XLSX.writeFile(workbook, `支出数据_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    return (
        <PageContent>
            <Box title={"支出数据"}
                extra={
                    <Space>
                        <Button type='primary' onClick={fetchqywxData}
                            loading={loadingQYWX}>从企业微信同步马术报销数据</Button>
                        <Button type='primary' onClick={() => setSpNoModalVisible(true)}>按单号同步</Button>
                        <Button type='primary' onClick={exportXlsx}>导出Excel</Button>
                        <Upload
                            name="file"
                            listType="text"
                            className="avatar-uploader"
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            onChange={handleChange}
                        >
                            <Button icon={<UploadOutlined />} loading={loadingUpload}>Excel导入</Button>
                        </Upload>
                    </Space>
                }
            >

                {/* 选项卡切换 */}
                <div style={{ marginBottom: 16 }}>
                    <Space>
                        <Button
                            type={activeTab === '马术报销' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('马术报销')}
                        >
                            马术报销
                        </Button>
                        <Button
                            type={activeTab === '马术支出' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('马术支出')}
                        >
                            马术支出
                        </Button>
                        <Button
                            type={activeTab === '马术退款' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('马术退款')}
                        >
                            马术退款
                        </Button>
                    </Space>
                </div>

                {/* 搜索表单 - 使用Form组件实现 */}
                <div style={{ marginBottom: 16, padding: '16px', background: '#f5f5f5', borderRadius: '6px' }}>
                    <Form
                        form={form}
                        layout="inline"
                        initialValues={searchParams}
                        onFinish={handleSearch}
                    >
                        {/* 第一行：审批编号、来源、提交日期 */}
                        <Row gutter={16} style={{ width: '100%', marginBottom: 16 }}>
                            <Col span={8}>
                                <Form.Item name="sp_no" label="审批编号" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input placeholder="请输入审批编号" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="dateRange" label="提交日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <RangePicker placeholder={['开始日期', '结束日期']} style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* 第二行：金额范围、事由、操作按钮 */}
                        <Row gutter={16} style={{ width: '100%' }}>
                            <Col span={8}>
                                <Form.Item label="金额范围" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input.Group compact>
                                        <Form.Item name="je_min" noStyle>
                                            <Input placeholder="最小金额" style={{ width: '50%' }} />
                                        </Form.Item>
                                        <Form.Item name="je_max" noStyle>
                                            <Input placeholder="最大金额" style={{ width: '50%' }} />
                                        </Form.Item>
                                    </Input.Group>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="bz" label="事由" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input placeholder="请输入事由" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Space>
                                        <Button type="primary" htmlType="submit">搜索</Button>
                                        <Button onClick={handleReset}>重置</Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <Space>
                    <span>
                        {hasSelected ? `已选择 ${selectedRowKeys.length} 项` : ''}
                    </span>
                    {activeTab === '马术报销' ? (
                        <>
                            添加付款日期：<DatePicker value={fkrq} onChange={(e) => setFkrq(e)} />
                            <Button type="primary" disabled={!hasSelected || !fkrq}
                                onClick={handleSetFKRQ}>确认添加</Button>
                        </>
                    ) : (
                        <Button type="primary" disabled={!hasSelected}
                            onClick={handleGenerateFKD}
                        >
                            生成付款单
                        </Button>
                    )}
                    <Popconfirm
                        title="确认删除选中项吗？"
                        onConfirm={handleDelete}
                        okText="确定"
                        cancelText="取消"
                        disabled={!hasSelected}
                    >
                        <Button type="danger" disabled={selectedRowKeys.length !== 1}>
                            删除
                        </Button>
                    </Popconfirm>
                </Space>

                <Table
                    dataSource={filteredData}
                    rowKey={"id"}
                    // pagination={tableParams.pagination}
                    pagination={false}
                    loading={loading}
                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    scroll={{
                        x: 1600,
                        y: "calc(100vh - 320px)",
                    }}
                >
                    {/*自动编号*/}
                    <Column title="审批编号" dataIndex="sp_no" key="审批编号" width={150} fixed={'left'} />
                    <Column title="入账日期" dataIndex="rz_date" key="入账日期" width={120}
                        render={(text, record) => {
                            const val = text || record.date;
                            return val ? (
                                <a onClick={() => handleOpenDateModal(record)}>{val}</a>
                            ) : '-';
                        }}
                    />
                    <Column title="金额" dataIndex="je" key="金额" width={100} />
                    <Column title="事由" dataIndex="bz" key="事由" />
                    <Column title="提交人" dataIndex="applyer" key="提交人" width={120} />
                    <Column 
                        title="附件" 
                        dataIndex="images" 
                        key="images" 
                        width={120}
                        render={(images) => {
                            if (!images) return '-';
                            try {
                                const imageList = JSON.parse(images);
                                if (!Array.isArray(imageList) || imageList.length === 0) return '-';
                                return (
                                    <a onClick={() => {
                                        setPreviewImageList(imageList);
                                        setPreviewImageIndex(0);
                                        setImagePreviewVisible(true);
                                    }}>
                                        共{imageList.length}个附件
                                    </a>
                                );
                            } catch (e) {
                                return '-';
                            }
                        }}
                    />
                    <Column title="支出方式" dataIndex="zcfs" key="支出方式" width={130}
                        filters={[{
                            text: '对公付款',
                            value: '对公付款',
                        },{
                            text: '垫付报销',
                            value: '垫付报销',
                        }]}
                        onFilter={(value, record) => (record.zcfs || '').replace('（需支付截屏）', '') === value}
                        render={(text) => text ? text.replace('（需支付截屏）', '') : text}
                    />
                    <Column title="审批状态" dataIndex="sp_status" key="sp_status" width={120} fixed={'right'}
                        filters={Object.entries(SP_STATUS_MAP).map(([value, { text }]) => ({
                            text,
                            value: parseInt(value)
                        }))}
                        onFilter={(value, record) => record.sp_status === value}
                        render={(status) => {
                            const config = SP_STATUS_MAP[status];
                            if (config) {
                                return <Tag color={config.color}>{config.text}</Tag>;
                            }
                            return status;
                        }}
                    />
                    {activeTab === '马术报销' ? (
                        <Column title="付款日期" dataIndex="fkrq" key="fkrq" width={110} fixed={'right'}
                            filters={[{
                                text: '已设置',
                                value: '已设置',
                            }, {
                                text: '未设置',
                                value: '未设置',
                            }]}
                            onFilter={(value, record) => value === '已设置' ? !!record.fkrq : !record.fkrq}
                            render={(text) => text || '-'}
                        />
                    ) : (
                        <Column title="付款单" dataIndex="fkd_id" key="fkd_id" width={140} fixed={'right'}
                            filters={[{
                                text: '已付',
                                value: '已付',
                            }, {
                                text: '未付',
                                value: '未付',
                            }, {
                                text: '未生成',
                                value: '未生成',
                            }]}
                            onFilter={(value, record) => {
                                if (value === '未生成') return record.fkd_id === null;
                                if (value === '已付') return record.fkd_id !== null && !!record.fkd_fkrq;
                                return record.fkd_id !== null && !record.fkd_fkrq;
                            }}
                            render={(text, record) => {
                                if (!text) {
                                    return <span style={{color: '#bbb'}}>未生成</span>
                                }
                                const paid = !!record.fkd_fkrq;
                                return (
                                    <Link onClick={() => {
                                        setDetailModalid(text);
                                    }}>{paid ? '已付' : '未付'}（{text}）</Link>
                                )
                            }}
                        />
                    )}
                    <Column title="科目" dataIndex="coa_id" key="科目" width={160} fixed={'right'}
                        render={(coaId, record) => {
                            if (!coaId) return '-';
                            const node = coaMap[coaId];
                            if (!node) return '-';
                            return (
                                <a onClick={() => setSubjectModal({node, record})}>{node.name}</a>
                            );
                        }}
                    />
                </Table>
            </Box>
            {!!detailModal && <ZcfkdEditModal
                list={detailModal}
                onCancel={() => {
                    setDetailModal(null);
                }}
                onOk={(id) => {
                    setDetailModal(null);
                    setDetailModalid(id);
                }}
            />}
            {!!detailModalid && <ZcfkDetailModal
                id={detailModalid}
                onCancel={() => {
                    setDetailModalid(null);
                }}
                onOk={() => {
                    setDetailModalid(null);
                }}
            />}
            {/* 调整入账日期弹窗 */}
            <Modal
                title={`调整入账日期（${dateModal ? dateModal.sp_no : ''}）`}
                open={!!dateModal}
                onOk={handleSaveDate}
                confirmLoading={dateLoading}
                onCancel={() => setDateModal(null)}
                okText="保存"
                cancelText="取消"
                width={400}
            >
                <div style={{marginBottom: 12}}>
                    <span style={{color: '#888'}}>提交日期：</span>
                    <span>{dateModal ? dateModal.date : ''}</span>
                </div>
                <div style={{marginBottom: 12}}>
                    <span style={{color: '#888'}}>入账日期：</span>
                    <DatePicker
                        style={{width: 240}}
                        value={dateValue}
                        onChange={setDateValue}
                        placeholder="请选择入账日期"
                        allowClear
                    />
                </div>
                <div style={{color: '#bbb', fontSize: 12}}>留空=恢复提交日期</div>
            </Modal>
            {/* 科目信息弹窗 */}
            <Modal
                title="科目信息"
                open={!!subjectModal}
                onCancel={() => setSubjectModal(null)}
                footer={[
                    <Button key="close" onClick={() => setSubjectModal(null)}>关闭</Button>,
                    <Button key="edit" type="primary" onClick={() => {
                        const {node, record} = subjectModal;
                        // 支出登记页按付款日期(fkrq)归集月份，优先用付款日期跳转，无付款日期时退回提交日期
                        const monthSource = record.fkrq || record.date;
                        const monthParam = monthSource ? moment(monthSource).format('YYYY-MM') : '';
                        props.history.push(`/duizhang/zcdj?coa_id=${node.id}${monthParam ? `&month=${monthParam}` : ''}`);
                    }}>修改</Button>,
                ]}
            >
                {subjectModal && (() => {
                    const {node} = subjectModal;
                    return (
                        <Descriptions column={1} size="small" bordered>
                            <Descriptions.Item label="科目名称">{node.name}</Descriptions.Item>
                            <Descriptions.Item label="科目全称">{getCoaPath(node)}</Descriptions.Item>
                            <Descriptions.Item label="部门">{node.department || '-'}</Descriptions.Item>
                            <Descriptions.Item label="年份">{node.year || '-'}</Descriptions.Item>
                        </Descriptions>
                    );
                })()}
            </Modal>
            {/* 按审批单号同步弹窗 */}
            <Modal
                title="按审批单号同步"
                open={spNoModalVisible}
                onOk={handleSyncBySpNo}
                confirmLoading={loadingSpNoSync}
                onCancel={() => {
                    setSpNoModalVisible(false);
                    setSpNoSync('');
                }}
                okText="同步"
                cancelText="取消"
            >
                <Input
                    placeholder="请输入审批单号"
                    value={spNoSync}
                    onChange={(e) => setSpNoSync(e.target.value)}
                    onPressEnter={handleSyncBySpNo}
                    allowClear
                />
            </Modal>
            {/* 图片幻灯片预览 */}
            <Modal
                title={`附件预览（${previewImageIndex + 1}/${previewImageList.length}）`}
                open={imagePreviewVisible}
                onCancel={() => setImagePreviewVisible(false)}
                footer={null}
                width="80%"
                style={{ top: '5%' }}
            >
                <div style={{ position: 'relative', textAlign: 'center', userSelect: 'none' }}>
                    {previewImageList.length > 1 && (
                        <>
                            <Button
                                type="text"
                                icon={<LeftOutlined />}
                                style={{
                                    position: 'absolute',
                                    left: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 1,
                                    fontSize: 24,
                                    height: 80,
                                    width: 48,
                                }}
                                onClick={() => setPreviewImageIndex(prev => 
                                    prev === 0 ? previewImageList.length - 1 : prev - 1
                                )}
                            />
                            <Button
                                type="text"
                                icon={<RightOutlined />}
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 1,
                                    fontSize: 24,
                                    height: 80,
                                    width: 48,
                                }}
                                onClick={() => setPreviewImageIndex(prev => 
                                    prev === previewImageList.length - 1 ? 0 : prev + 1
                                )}
                            />
                        </>
                    )}
                    <img
                        src={previewImageList[previewImageIndex]}
                        alt={`附件${previewImageIndex + 1}`}
                        loading="lazy"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                        }}
                    />
                </div>
                {previewImageList.length > 1 && (
                    <div style={{ textAlign: 'center', marginTop: 12, display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
                        {previewImageList.map((img, index) => (
                            <div
                                key={index}
                                onClick={() => setPreviewImageIndex(index)}
                                style={{
                                    cursor: 'pointer',
                                    width: 56,
                                    height: 56,
                                    border: index === previewImageIndex ? '2px solid #1677ff' : '2px solid #d9d9d9',
                                    borderRadius: 4,
                                    overflow: 'hidden',
                                    opacity: index === previewImageIndex ? 1 : 0.5,
                                    transition: 'all 0.2s',
                                }}
                            >
                                <img
                                    src={img}
                                    alt={`缩略图${index + 1}`}
                                    loading="lazy"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </Modal>
        </PageContent>
    )
}

export default withRouter(Zcsj);